import React from 'react';
import NavbarUnderStaff from './NavbarUnderStaff';
import ContactListStaff from './ContactListStaff';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="app-index">
                <NavbarUnderStaff />
                <ContactListStaff />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/Staff/IndexStaff.js